<template>
	<div class="news_detail">
		<h1 class="title">{{ news.title }}</h1>
		<h3 class="date">{{ news.date }}</h3>
		<div v-html="news.content" class="content"></div>
		<div v-if="prev || next" class="switch_footer clear_both">
			<a v-if="prev" class="text_theme text_one" style="float: left;" @click="handlePrevClick">上一条：{{ prev }}</a>
			<a v-if="next" class="text_theme text_one" style="float: right;text-align: right;" @click="handleNextClick">下一条：{{ next }}</a>
		</div>
	</div>
</template>

<script>
	import News from '../../../db/news.js';
	
	export default {
		mounted() {
			this.init();
		},
		data() {
			return {
				news: {},
				prev: '',
				next: ''
			}
		},
		methods: {
			/********************** @Events ************************/
			// 点击上一条
			handlePrevClick() {
				this.$router.push({
					path: `/index/news?index=${ this.index - 1 }`
				});
			},
			// 点击下一条
			handleNextClick() {
				this.$router.push({
					path: `/index/news?index=${ this.index + 1 }`
				});
			},
			
			/********************** @Function ************************/
			// 初始化
			init() {
				this.index = parseInt(this.$route.query.index);
				this.news = News[this.index];
				this.prev = News[this.index - 1] ? News[this.index - 1].title : '';
				this.next = News[this.index + 1] ? News[this.index + 1].title : '';
			}
		},
		watch: {
			$route(){
				this.init();
			}
		}
	}
</script>

<style scoped>
	.news_detail{ width: 1200px;margin: 40px auto 100px;padding: 80px 40px;box-shadow: 2px 6px 26px #ccc; }
	.news_detail .title{ font-size: 30px;font-weight: bold;text-align: center;line-height: 42px; }
	.news_detail .date{ font-size: 18px;color: #ccc;text-align: center;line-height: 34px; }
	.news_detail .content{ margin-top: 40px;text-indent: 2em;line-height: 24px; }
	.news_detail .content img{ max-width: 100%; }
	.news_detail .switch_footer{ margin-top: 40px;line-height: 24px; }
	.news_detail .switch_footer a{ display: block;width: 300px; }
	.news_detail .switch_footer a:hover{ text-decoration: underline; }
</style>
